import { Controller } from '@hotwired/stimulus'
import { createApp } from 'vue'
import LoadingWheel from '@/components/loading_wheel.vue'
import VueElementLoading from 'vue-element-loading'

export default class extends Controller {
  static targets = ['loading']
  connect() {
    super.connect()
  }
  load() {
    const app = createApp(LoadingWheel, {
      isLoading: true
    })
    app.component('VueElementLoading', VueElementLoading)
    app.mount(this.loadingTarget)
  }
}
